import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useNotificationPermissions } from "@/hooks/useNotificationPermissions";
import { useAuth } from "@/hooks/useAuth";

export const VapidKeyUpdateBanner = () => {
  const { user } = useAuth();
  const { vapidKeyUpdateDetected, requestNotificationPermission } = useNotificationPermissions(user?.id);

  if (!vapidKeyUpdateDetected) {
    return null;
  }

  return (
    <Alert className="border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-900/20">
      <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      <AlertTitle className="text-amber-800 dark:text-amber-200">
        Notification Update Required
      </AlertTitle>
      <AlertDescription className="text-amber-700 dark:text-amber-300">
        We've updated our notification security. Please re-enable notifications to continue receiving them.
        <div className="mt-3">
          <Button 
            onClick={requestNotificationPermission}
            variant="outline" 
            size="sm"
            className="border-amber-300 text-amber-800 hover:bg-amber-100 dark:border-amber-600 dark:text-amber-200 dark:hover:bg-amber-800/30"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Update Notifications
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};